import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 10h-4v-4","key":"svg-0"}],["path",{"d":"M20 4l-6 6","key":"svg-1"}],["path",{"d":"M6 14h4v4","key":"svg-2"}],["path",{"d":"M10 14l-6 6","key":"svg-3"}]]

const IconArrowsDiagonalMinimize2 = createReactComponent('outline', 'arrows-diagonal-minimize-2', 'ArrowsDiagonalMinimize2', __iconNode);

export default IconArrowsDiagonalMinimize2;